import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface FaqItemProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  header: ReactNode;
}

export const FaqItem = forwardRef<HTMLDivElement, FaqItemProps>(
  ({ header, content, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames(
        "wb-flex wb-flex-col wb-gap-3 wb-py-7 md:wb-gap-5 wb-border-b wb-border-primary last:wb-border-0",
        className,
      )}
      {...rest}
    >
      {header}
      {content}
    </div>
  ),
);

FaqItem.displayName = "FaqItem";
